import FVector from '@data/geometry/FVector';
import { Button } from '@mui/material';
import React from 'react';

type PolygonActionButtonsProps = {
    positions: FVector[];
    draw2D: any;
    onSave: () => void;
    saveButtonId?: string;
    disabled?: boolean;
    forceVisible?: boolean;
};

export const PolygonActionButtons: React.FC<PolygonActionButtonsProps> = ({
    positions,
    draw2D,
    onSave,
    saveButtonId,
    disabled = false,
    forceVisible = false,
}) => {
    const hasEnoughPoints = positions.length >= 3;

    if (forceVisible || draw2D?.isRunning()) {
        return (
            <Button
                id={saveButtonId}
                variant="contained"
                onClick={onSave}
                disabled={!hasEnoughPoints || disabled}
                color={hasEnoughPoints && !disabled ? 'primary' : 'inherit'}
                sx={{ alignSelf: 'flex-start', minWidth: '110px', px: 2, mt: 1 }}
            >
                Save Polygon
            </Button>
        );
    }

    return null;
};
